import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { HomeHero } from '../components/home/HomeHero';
import { ReviewsSection } from '../components/home/ReviewsSection';
import { ComplaintExplorer } from '../components/ComplaintExplorer';
import { CtaBand } from '../components/CtaBand';
import { TrainingClinic } from '../components/TrainingClinic';
import { TeamMemberCard } from '../components/TeamMemberCard';
import { careSteps, images } from '../data/clinic';
import { team } from '../data/team';
export function Home() {
  const specialists = team[0];
  return <>
      <HomeHero data-id="element-594" data-mp="29fc1ke9hphs7" />

      <section id="waar-pijn" className="scroll-mt-28" data-id="element-595" data-mp="29etwcs4unt85">
        <div className="mx-auto max-w-7xl px-5 py-20 lg:px-8 lg:py-24" data-id="element-596" data-mp="2dhyvqltmvesk">
          <div className="mb-10 max-w-2xl" data-id="element-597" data-mp="3kvae4s3vmly6">
            <h2 className="font-display text-3xl font-semibold tracking-tight text-ink sm:text-[44px] sm:leading-tight" data-id="element-598" data-mp="3kuihddyjmi6b">
              Waar heeft u pijn?
            </h2>
            <p className="mt-4 text-lg leading-relaxed text-muted" data-id="element-599" data-mp="30xb7fy9sinu3">
              Kies uw pijnklacht. U ziet direct welke behandelingen wij bieden.
            </p>
          </div>
          <ComplaintExplorer data-id="element-600" data-mp="2qylnlzyc2tb7" />
        </div>
      </section>

      <section className="border-t border-line bg-surface" data-id="element-601" data-mp="2qx0vegzhrmgi">
        <div className="mx-auto grid max-w-7xl gap-12 px-5 py-20 lg:grid-cols-2 lg:gap-20 lg:px-8 lg:py-24" data-id="element-602" data-mp="2mxjork8bwj9r">
          <div data-id="element-603" data-mp="2hy7518cr7sbe">
            <h2 className="font-display text-3xl font-semibold tracking-tight text-ink sm:text-4xl" data-id="element-604" data-mp="2hyp6cje9wwq6">Tijd voor echte aandacht</h2>
            <p className="mt-5 text-lg leading-relaxed text-muted" data-id="element-605" data-mp="2d546elt4dsoc">
              Onze kliniek biedt medisch specialistische behandelingen op het gebied van pijnklachten, overgangsklachten en
              carpaal tunnel syndroom.
            </p>
            <img src={images.consult} alt="Pijnspecialist van Excellent Care Clinics" className="mt-10 aspect-[16/10] w-full rounded-3xl object-cover" data-id="element-606" data-mp="1z7pdh73nr2rm" />
          </div>
          <div className="lg:pt-2" data-id="element-607" data-mp="1kjxql7bal5a2">
            <h3 className="font-display text-xl font-semibold text-ink" data-id="element-608" data-mp="1kn3ckdomjr1k">Zo werkt het</h3>
            <ol className="mt-8" data-id="element-609" data-mp="1ok7umefixlma">
              {careSteps.map((step, index) => <li key={step.title} className="relative flex gap-6 pb-10 last:pb-0" data-id="element-610" data-mp="1aoduajstg4ks" data-mpi={index}>
                  {index < careSteps.length - 1 && <span className="absolute left-5 top-11 h-[calc(100%-2.75rem)] w-px bg-line" aria-hidden="true" data-id="element-611" data-mp="23bgs19po4b9z" />}
                  <span className="relative flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-white font-display text-sm font-semibold text-primary ring-1 ring-line" data-id="element-612" data-mp="28904c42t2dza">
                    {index + 1}
                  </span>
                  <div className="pt-1.5" data-id="element-613" data-mp="1yi5ih0th1ged">
                    <p className="font-display text-lg font-semibold text-ink" data-id="element-614" data-mp="2m91gifoit7u2">{step.title}</p>
                    <p className="mt-1.5 text-[15px] leading-relaxed text-muted" data-id="element-615" data-mp="2r12m5ir6o0b4">{step.text}</p>
                  </div>
                </li>)}
            </ol>
          </div>
        </div>
      </section>

      <ReviewsSection data-id="element-616" data-mp="alxx31o8i917" />

      <section className="mx-auto max-w-7xl px-5 py-20 lg:px-8 lg:py-24" data-id="element-617" data-mp="amh7lxbk1v57">
        <div className="flex flex-col justify-between gap-6 sm:flex-row sm:items-end" data-id="element-618" data-mp="ocudlu4vyzrw">
          <div className="max-w-xl" data-id="element-619" data-mp="kdlioly40vur">
            <h2 className="font-display text-3xl font-semibold tracking-tight text-ink sm:text-4xl" data-id="element-620" data-mp="ken6lr085ctw">Onze pijnspecialisten</h2>
            <p className="mt-4 text-lg leading-relaxed text-muted" data-id="element-621" data-mp="3nt975ji9eit7">
              Samen met pijnconsulenten, verpleegkundigen en het secretariaat staan zij voor u klaar.
            </p>
          </div>
          <Link to="/team" className="inline-flex items-center gap-2 whitespace-nowrap text-[15px] font-semibold text-primary hover:text-primary-dark" data-id="element-622" data-mp="ot8kv6x21h8">
            Bekijk het hele team
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-623" data-mp="1c4hwppvwp6jm" />
          </Link>
        </div>
        <ul className="mt-10 grid grid-cols-2 gap-x-5 gap-y-10 sm:grid-cols-3 lg:grid-cols-4" data-id="element-624" data-mp="27eohy3sx9iq9">
          {specialists.members.slice(0, 4).map(m => <li key={m.name} data-id="element-625" data-mp="2cf2gmv8mvgbm">
              <TeamMemberCard member={m} data-id="element-626" data-mp="2hccff1hwx4c4" />
            </li>)}
        </ul>
      </section>

      <TrainingClinic data-id="element-627" data-mp="2mavxgqtdxvz7" />
      <CtaBand data-id="element-628" data-mp="2mc720sunn7rd" />
    </>;
}